<template>
  <div class="bottom-drawer-select relative" :class="[props.block && 'w-full', props.containerClass]">
    <bottom-drawer
      v-if="appStore.isMobileScreen"
      :title="props.title"
      :is-footer-shown="true"
      @after-leave="onDrawerAfterLeave"
      @submit="onDrawerSubmit"
    >
      <template #trigger="{ open }">
        <div class="absolute w-full h-full z-5" @click="open"></div>
      </template>
      <template #default>
        <etg-radio-group v-model="radioValue" :options="radioOptions" item-class="border-b border-gray-40" />
      </template>
    </bottom-drawer>

    <etg-select v-bind="$attrs" v-model="selectedValue" :options="props.options" :disabled="props.disabled" />
  </div>
</template>

<script lang="ts" setup>
import BottomDrawer from '@/components/common/bottom-drawer.vue'
import EtgRadioGroup from '@/components/form/etg-radio-group.vue'

import { useAppStore } from '@/store/app'
import type { EtgSelectProps } from '@/types/component'

interface Props {
  title: string
  options: EtgSelectProps['options']
  block?: boolean
  containerClass?: string
  disabled?: boolean
}

defineOptions({ inheritAttrs: false })

const props = defineProps<Props>()

const selectedValue = defineModel<string | number | undefined>({ required: true })

const appStore = useAppStore()

const radioValue = ref(selectedValue.value)

const radioOptions = computed(() => props.options?.map(option => ({ id: option.value, name: option.label })) || [])

function onDrawerAfterLeave() {
  radioValue.value = selectedValue.value
}

function onDrawerSubmit() {
  selectedValue.value = radioValue.value
}
</script>
